export const findKeysByPurchaseOrderId = (items) => (purchaseOrderId) => {
    return Object.keys(items).filter(
        (key) => items[key].transaction.purchaseOrderId === purchaseOrderId
    );
};

export const findKeysByItemId = (items) => (itemId) => {
    return Object.keys(items).filter((key) => items[key].itemId === itemId);
};
